import apisauce from 'apisauce';
import history from '../Services/history';

const REDIRECT_CODES = [8, 19];
const REDIRECT_STATUSES = [429];

const create = (baseURL) => { // home
    const api = apisauce.create({
        baseURL,
        headers: {
            Accept : 'application/json',
        }
    });

    api.addAsyncRequestTransform(request => async () => {
        const accessToken = JSON.parse(localStorage.getItem('access_token'));
        const entityUuid = JSON.parse(localStorage.getItem('entity_uuid'));
        if (!accessToken || !entityUuid){
            localStorage.clear();
            history.push('/login');
            return;
        }
        if (accessToken) {
            request.headers['x-access-token'] = accessToken;
        }
        if (entityUuid) {
            request.headers['x-entity-token'] = entityUuid;
        }
    });

    api.addMonitor(response => {
        if (!response.ok) {
            // ACL error, redirect to error acl page
            if (response.data.code > 1000){
                history.push('/error/not-allowed');
                return;
            }

            // Entity deactivated
            if (response.data.code === 19){
                localStorage.clear();
                history.push('/login');
                return;
            }

            for (let i in REDIRECT_STATUSES) {
                if (response.status === REDIRECT_STATUSES[i]) {
                    localStorage.clear();
                    history.push('/login');
                    break;
                }
                if (response.status === 403) {
                    for (let j in REDIRECT_CODES) {
                        if (response.data.code === REDIRECT_CODES[j]) {
                            localStorage.clear();
                            history.push('/login');
                            break;
                        }
                    }
                }
            }
        }
    });

    if (true) {
        api.addMonitor(response => console.log('response: ', response));
    }

    const doLogin = (username, password) => {
        return api.post('/access-token', { username, password });
    };

    const logout = (token) => {
        return api.delete(`/access-token/${token}`);
    };

    const checkAuth = (token) => {
        return api.get(`/access-token/${token}`);
    };

    const getOtCollection = (query) => {
        return api.get(`/ot`, query);
    };
    const getOtResource = (uuid, query = {}) => {
        return api.get(`/ot/${uuid}`, query);
    };
    const deleteOtResource = (uuid) => {
        return api.delete(`/ot/${uuid}`);
    };
    const postOtCollection = (ot, query) => {
        return api.post('/ot', ot, query);
    };
    const patchOtResource = (uuid, ot, query) => {
        return api.patch(`/ot/${uuid}`, ot, {params: query});
    };
    const getOtDetailsCollection = (uuid, query = {}) => {
        return api.get(`/ot/${uuid}/detail`, query);
    };
    const postOtDetailCollection = (uuid, detail, query = {}) => {
        return api.post(`/ot/${uuid}/detail`, detail, query);
    };
    const patchOtDetailResource = (uuid, detail, query) => {
        return api.patch(`/detail/${uuid}`, detail, {params: query});
    };
    const deleteOtDetailResource = (uuid) => {
        return api.delete(`/detail/${uuid}`);
    };

    const getOtTransactionsCollection = (uuid, query = {}) => {
        return api.get(`/ot/${uuid}/transaction`, query);
    };
    const postOtTransactionCollection = (uuid, transaction, query = {}) => {
        return api.post(`/ot/${uuid}/transaction`, transaction, query);
    };
    const deleteOtTransactionResource = (uuid) => {
        return api.delete(`/transaction/${uuid}`);
    };

    const getOtAssetsCollection = (uuid, query = {}) => {
        return api.get(`/ot/${uuid}/asset`, query);
    };
    const postOtAssetCollection = (uuid, asset, query = {}) => {
        return api.post(`/ot/${uuid}/asset`, asset, query);
    };
    const deleteOtAssetResource = (otUuid, assetId) => {
        return api.delete(`/ot/${otUuid}/asset/${assetId}`);
    };

    const postQuoteNotificationCollection = (uuid, message) => {
        return api.post(`/ot/${uuid}/notification`, message);
    };

    const getCustomerCollection = (query) => {
        return api.get(`/customer`, query);
    };
    const postCustomerCollection = (customer, query = {}) => {
        return api.post(`/customer`, customer, query);
    };
    const deleteCustomerResource = (id) => {
        return api.delete(`/customer/${id}`);
    };
    const getCustomerResource = (id, query = {}) => {
        return api.get(`/customer/${id}`, query);
    };
    const patchCustomerResource = (id, customer, query) => {
        return api.patch(`/customer/${id}`, customer, {params: query});
    };

    const getUserCollection = (query) => {
        return api.get(`/user`, query);
    };
    const getUserResource = (id, query = {}) => {
        return api.get(`/user/${id}`, query);
    };
    const postUserCollection = (roleId, user, query = {}) => {
        return api.post(`/role/${roleId}/user`, user, query);
    };
    const patchUserResource = (id, user, query) => {
        return api.patch(`/user/${id}`, user, {params: query});
    };
    const deleteUserResource = (id) => {
        return api.delete(`/user/${id}`);
    };

    const getRoleCollection = (query) => {
        return api.get(`/role`, query);
    };
    const getChangelogCollection = (entityName, resourceId, query) => {
        return api.get(`/entity/${entityName}/resource/${resourceId}/changelog`, query);
    };

    const getEntityResource = (uuid, query = {}) => {
        return api.get(`/entity/${uuid}`, query);
    };
    const patchEntityResource = (uuid, entity, query) => {
        return api.patch(`/entity/${uuid}`, entity, {params: query});
    };

    const getProductCollection = (query) => {
        return api.get(`/product`, query);
    };
    const postProductCollection = (product, query = {}) => {
        return api.post(`/product`, product, query);
    };
    const deleteProductResource = (uuid) => {
        return api.delete(`/product/${uuid}`);
    };
    const getProductResource = (uuid, query = {}) => {
        return api.get(`/product/${uuid}`, query);
    };
    const patchProductResource = (uuid, product, query) => {
        return api.patch(`/product/${uuid}`, product, {params: query});
    };

    const getProfileCollection = (query = {}) => {
        return api.get(`/profile`, query);
    };
    const putProfileCollection = (profile, query = {}) => {
        return api.put(`/profile`, profile, {params: query});
    };

    const postQuoteCollection = (quote, query = {}) => {
        return api.post(`/quote`, quote, {params: query});
    };

    const getOtDiscountsCollection = (uuid, query = {}) => {
        return api.get(`/ot/${uuid}/discount`, query);
    };
    const postOtDiscountCollection = (uuid, discount, query = {}) => {
        return api.post(`/ot/${uuid}/discount`, discount, query);
    };
    const deleteOtDiscountResource = (uuid) => {
        return api.delete(`/discount/${uuid}`);
    };

    /** Reports */
    const getReport = (name, input = {}) => {
        return api.get(`/report/${name}`, input);
    };

    const getOtAttributes = (uuid, query = {}) => {
        return api.get(`/ot/${uuid}/attribute`, query);
    };
    const createOtAttribute = (uuid, detail, query = {}) => {
        return api.post(`/ot/${uuid}/attribute`, detail, query);
    };
    const deleteOtAttribute = (attributeId, otUuid) => {
        return api.delete(`/ot/${otUuid}/attribute/${attributeId}`);
    };

    const getUnits = () => {
        return api.get(`/unit`);
    };
    const createUnit = (unit, query = {}) => {
        return api.post(`/unit`, unit, query);
    };
    const deleteUnit = (id) => {
        return api.delete(`/unit/${id}`);
    };

    const createQuickQuote = (data = {}) => {
        return api.post(`/quick-quote`, data);
    };

    const createQuickOt = (data = {}) => {
        return api.post(`/quick-ot`, data);
    };

    return {
        doLogin,
        logout,
        checkAuth,

        // Profile
        getProfileCollection,
        putProfileCollection,

        // OT endpoints
        getOtCollection,
        postOtCollection,
        getOtResource,
        patchOtResource,
        deleteOtResource,
        postQuoteNotificationCollection,

        // OT details
        getOtDetailsCollection,
        postOtDetailCollection,
        patchOtDetailResource,
        deleteOtDetailResource,
        // OT transactions
        getOtTransactionsCollection,
        postOtTransactionCollection,
        deleteOtTransactionResource,
        // OT assets
        getOtAssetsCollection,
        postOtAssetCollection,
        deleteOtAssetResource,
        // OT discounts
        getOtDiscountsCollection,
        postOtDiscountCollection,
        deleteOtDiscountResource,

        // Customer
        getCustomerCollection,
        postCustomerCollection,
        deleteCustomerResource,
        getCustomerResource,
        patchCustomerResource,

        // User endpoints
        getUserCollection,
        getUserResource,
        postUserCollection,
        patchUserResource,
        deleteUserResource,
        // Roles
        getRoleCollection,

        // Changelog
        getChangelogCollection,

        // Entity
        getEntityResource,
        patchEntityResource,

        // Product
        getProductCollection,
        postProductCollection,
        deleteProductResource,
        getProductResource,
        patchProductResource,

        // Quote
        postQuoteCollection,

        // Reports
        getReport,

        // OT Attributes
        getOtAttributes,
        createOtAttribute,
        deleteOtAttribute,

        getUnits,
        createUnit,
        deleteUnit,

        createQuickQuote,
        createQuickOt,
    };
};


export default {
    create
}



// WEBPACK FOOTER //
// ./src/Services/Api.js